import { Avatar, Divider, Grid } from "@mui/material";
import NotificationIcon from "../../assets/images/NotificationIcon.png";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import Menu from "@mui/material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuItem from "@mui/material/MenuItem";
import TabIcon from "@mui/icons-material/Tab";

import "./styles.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotification } from "../../redux/slices/notification.slice";
import RouteContext from "../../utils/context/RouteContext";
import { roles } from "../sidenav/constant";

const Header = ({ title }) => {
  const { role } = useContext(RouteContext);
  const FunctionLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("user");
  };
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);

  const dispatch = useDispatch();
  const noScrollbarStyle = {
    WebkitScrollbar: {
      display: "none",
    },
  };

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const notificationList = useSelector((store) => {
    return store?.notification?.notificationData;
  });

  useEffect(() => {
    if (role === roles?.SUB_ADMIN) dispatch(fetchNotification({ page, limit }));
  }, [page]);

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const navigate = useNavigate();

  const handleNotificationClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setAnchorEl(null);
  };

  const name = localStorage.getItem("name");
  const nameWords = name ? name.split(" ") : null;

  return (
    <>
      <Grid
        container
        className="header-container header_sticky "
        sx={{ zIndex: "10" }}
      >
        <Grid item xs={10}>
          <h1 className="header-heading-container">{title}</h1>
        </Grid>

        <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          {/* notification dropdown */}
          {role === roles?.SUB_ADMIN && (
            <div
              onClick={handleNotificationClick}
              style={{
                padding: ".4rem .65rem",
                border: "1px solid #F2F2F2",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              <img
                src={NotificationIcon}
                alt="notification icon"
                style={{ height: "1.4rem", cursor: "pointer" }}
              />
            </div>
          )}

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleNotificationClose}
            PaperProps={{
              style: {
                width: "26rem",
                borderRadius: ".8rem",
                padding: ".2rem",
              },
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <div style={{ paddingBottom: ".8rem" }}>
              <span
                style={{
                  color: "#262626",
                  fontWeight: "600",
                  paddingLeft: ".4rem",

                  fontSize: "1rem",
                }}
              >
                Notifications Today
              </span>
            </div>
            <div style={noScrollbarStyle}>
              {notificationList?.map((notif, idx) => (
                <MenuItem
                  key={idx}
                  sx={{ borderBottom: "1px solid #F2F2F2" }}
                  onClick={handleNotificationClose}
                >
                  <div style={{ padding: "0px .7rem" }}>
                    <TabIcon />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ color: "#262626", fontWeight: "500" }}>
                      {notif?.title}{" "}
                    </span>
                    <div>
                      <span style={{ color: "#737373" }}>
                        {notif?.description.slice(0, 40) + "..."}
                      </span>
                    </div>
                  </div>
                </MenuItem>
              ))}
            </div>

            <div
              style={{
                padding: ".5rem .5rem .2rem",
                overflow: "hidden",
              }}
            >
              <div style={{ float: "right", cursor: "pointer" }}>
                <span
                  style={{ color: "#1A5AFA" }}
                  onClick={() => {
                    navigate("/notifications");
                  }}
                >
                  View All Notification
                </span>
              </div>
            </div>
          </Menu>
          {role === roles?.SUB_ADMIN && (
            <Divider orientation="vertical" sx={{ height: "60%" }} />
          )}
          <Avatar
            onClick={handleMenuOpen}
            sx={{
              backgroundColor: "#1890FF",
              padding: "1rem",
              cursor: "pointer",
            }}
          >
            {nameWords && (
              <span
                style={{
                  fontWeight: "400",
                  fontSize: "0.875rem",
                }}
              >
                {`${nameWords[0]?.charAt(0).toUpperCase()}${
                  nameWords.length > 1
                    ? nameWords[nameWords.length - 1]?.charAt(0).toUpperCase()
                    : ""
                }`}
              </span>
            )}
          </Avatar>
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem style={{ height: "2rem" }} onClick={FunctionLogout}>
              <div style={{ paddingRight: ".5rem", height: "1.4rem" }}>
                <LogoutIcon />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ color: "#262626", fontWeight: "500" }}>
                  Logout
                </span>
              </div>
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>
    </>
  );
};

export default Header;
